import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.app;

export const appSelectors = {
  isLoading: createSelector(selector, (state) => state.isLoading),
  showModal: createSelector(selector, (state) => state.showModal),
  modalObject: createSelector(selector, (state) => state.modalObject),
  showContactUsModal: createSelector(
    selector,
    (state) => state.showContactUsModal,
  ),
  showLanguageMessageModal: createSelector(
    selector,
    (state) => state.showLanguageMessageModal,
  ),
  showLanguageSelectModal: createSelector(
    selector,
    (state) => state.showLanguageSelectModal,
  ),
  menuDetailPopupObject: createSelector(
    selector,
    (state) => state.menuDetailPopupObject,
  ),
  storeDetailPopupObject: createSelector(
    selector,
    (state) => state.storeDetailPopupObject,
  ),
  showMenuDetailPopup: createSelector(
    selector,
    (state) => state.showMenuDetailPopup,
  ),
  showStoreDetailPopup: createSelector(
    selector,
    (state) => state.showStoreDetailPopup,
  ),
};
